import apiService from "../ApiService";

export const ubisoftPYGActivate = (gameId: string) => {
  return apiService.post<void>({
    path: `v1/store/ubisoft/product/pyg/${gameId}`,
  });
};
